<template>
  <footer class="footer">
    <div class="footer_wrap">
      <el-row
        :gutter="20 "
        class="c_white"
      >
        <el-col :span="6">
          <div class="fs20">关于我们</div>
          <p class="margin-top-sm footer_one_text">
            深圳市智垒网科技术有限公司专注于智慧出行软件技术研发及推广，利用移动互联网，大数据及云计算等先进技术，帮助传统道路运输企业实现信息化......</p>
          <div class="clearfix margin-top-xs footer_one_btn_box">
            <div
              class="fr footer_one_btn"
              @click="goAbout"
            >查看更多 >></div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="fs20">最新案例</div>

          <p
            @click="goToUrl(item.name)"
            class="cursor_por footer_one_text margin-top-sm"
            v-for="(item,index) in case_list"
            :key="index"
            v-show="index==curindex"
            @mouseleave="caseLeave"
            @mouseenter="caseEnter"
          >
            {{item.title}}
            <br />
            <span style="opacity:0.75;">{{item.info}}</span>
          </p>
        </el-col>
        <el-col :span="6">
          <div class="fs20">服务范围</div>
          <ul class="margin-top-sm clearfix footer_three_ul">
            <li
              class="fs12"
              v-for="(item,index) in list"
              :key="index"
            >{{item}}</li>
          </ul>
        </el-col>
        <el-col :span="6">
          <div class="fs20">联系我们</div>
          <ul class="fs12 footer_four_ul margin-top-sm">
             <li>
              <i class="_phone"></i> 电话: 0755-36994096
            </li>
            <li>
              <i class="_call"></i> QQ：
              <a
                style="color:#ddd;"
                href="tencent://message/?uin=82805838&Site=sc.chinaz.com&Menu=yes"
                rel="nofollow"
                target="_blank"
              >82805838</a>
            </li>
            <li>
              <i class="_email"></i> 邮箱: marketing@witfort.net
            </li>
           
          </ul>
        </el-col>
      </el-row>
    </div>
    <div class="foot_bottom">
      <p class="copyright">@2018-{{yearCus}} 版权所有 Witfort 深圳市智垒网科技术有限公司
        <a
          href="https://beian.miit.gov.cn"
          target="_blank"
        >粤ICP备17071033号</a>
      </p>
    </div>
  </footer>
</template>

<script>
var caseN = null;
export default {
  data () {
    return {
      yearCus:'',
      list: [
        "出行软件",
        "定制开发",
        "技术运维",
        "安全防护",
        "运营顾问",
        "营销推广",
      ],
      curindex: 0,
      case_list: [
        {
          id: 1,
          title: "定制客运平台",
          info: "在班车客运业务的基础上开展定制客运服务",
          name: 'cusKc'
        },
        {
          id: 2,
          title: "数字城乡班车平台",
          info: "城际客运，城乡客运的互联网平台化",
          name: 'szbc'
        },
        {
          id: 3,
          title: "智能出租车平台",
          info: "出租车业务的互联网平台化",
          name: 'taxi'
        },
        {
          id: 4,
          title: "数字公交平台",
          info: "公交业务的互联网平台化和开展定制公交业务",
          name: 'szgj'
        },
        {
          id: 5,
          title: "数字包车平台",
          info: "包车客运、非定线旅游客运业务的互联网平台化",
          name: 'tourismSystem'
        }]
    };
  },
  mounted () {
    this.$nextTick(() => {
      this.yearCus = new Date().getFullYear();
      this.caseInterval();
    })
  },
  methods: {
    caseInterval () {
      caseN = setInterval(() => {
        this.curindex = this.curindex == (this.case_list.length - 1) ? 0 : (this.curindex + 1);
      }, 2000)
    },
    caseLeave () {
      if (caseN) {
        this.caseEnter();
      }
      this.caseInterval();
    },
    caseEnter () {
      clearInterval(caseN);
      caseN = null;
    },
    goToUrl (name) {
      this.$router.push({
        name
      })
    },
    goAbout () {
      this.$router.push({
        name: 'about'
      })
    }
  }
};
</script>

<style lang="stylus" scoped>
@import './index.styl'
</style>


// WEBPACK FOOTER //
// src/components/footb/index.vue